

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as SchemaTypes from '../schema/types'

import * as ReplayTypes from "./types"

export type LoanManualReplayKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'replay',unknown];

export type LoanManualReplayResponse = void;

export type LoanManualReplayVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        priority?: "low" | "normal" | "high" | "paymentProcessing" | "createPurchaseSync" | "datcon" | "autopay" | "loan" | "DLM" | "monitor" | "scra" | "loanSnapshot" | "elasticsearch" | "long";
        /**
         * @default
         *     none
         */
        regenerateStatements?: "none" | "missingOnly" | "all" | "true" | "false";
        startAt: string;
        reason: string;
        injectRoundingCleanup?: boolean;
    };
}

export const loanManualReplay = makeData<
  LoanManualReplayResponse,
  LoanManualReplayKey,
  LoanManualReplayVariables
>({
  method: 'post',
  name: 'loanManualReplay',
  summary: "Manually replay a loan",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/replay',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'replay', query],
})

export type RecordReplayDataKey = ['companies',string | undefined,'loans',string | undefined,'replay',string | undefined,'data',unknown];

export type RecordReplayDataResponse = void;

export type RecordReplayDataVariables = {
    companyId: string | undefined;
    loanId: string | undefined;
    creatingMessageId: string | undefined;
    body?: {
        executionStartedAt?: string;
        executionSucceededAt?: string;
        executionFailedAt?: string;
        replayFrom?: string;
        initialReplayableEvents?: number;
        totalEvents?: number;
    };
    query?: void;
}

export const recordReplayData = makeData<
  RecordReplayDataResponse,
  RecordReplayDataKey,
  RecordReplayDataVariables
>({
  method: 'post',
  name: 'recordReplayData',
  summary: "Record replay data",
  path: '/companies/{companyId}/loans/{loanId}/replay/{creatingMessageId}/data',
  queryKey: ({query, companyId,
loanId,
creatingMessageId,}) => ['companies',companyId,'loans',loanId,'replay',creatingMessageId,'data', query],
})

export type InternalPostReplaySideEffectsPostKey = ['companies',string | undefined,'loans',string | undefined,'post-replay-side-effects',unknown];

export type InternalPostReplaySideEffectsPostResponse = void;

export type InternalPostReplaySideEffectsPostVariables = {
    companyId: string | undefined;
    loanId: string | undefined;
    body?: {
        oldStatus: SchemaTypes.LoanStatus;
        /** The ID of the message that triggered the replay. */
        creatingMessageId: string;
    };
    query?: void;
}

export const internalPostReplaySideEffectsPost = makeData<
  InternalPostReplaySideEffectsPostResponse,
  InternalPostReplaySideEffectsPostKey,
  InternalPostReplaySideEffectsPostVariables
>({
  method: 'post',
  name: 'internalPostReplaySideEffectsPost',
  summary: "Run side-effects after replay",
  path: '/companies/{companyId}/loans/{loanId}/post-replay-side-effects',
  queryKey: ({query, companyId,
loanId,}) => ['companies',companyId,'loans',loanId,'post-replay-side-effects', query],
})

export type InternalPreReplayRefreshKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'pre-replay-refresh',unknown];

export type InternalPreReplayRefreshResponse = void;

export type InternalPreReplayRefreshVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: {
        replayTrigger: string;
        /** Date and time to begin replay from. */
        replayFrom: string;
    };
    query?: void;
}

export const internalPreReplayRefresh = makeData<
  InternalPreReplayRefreshResponse,
  InternalPreReplayRefreshKey,
  InternalPreReplayRefreshVariables
>({
  method: 'post',
  name: 'internalPreReplayRefresh',
  summary: "Pre-replay refresh",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/pre-replay-refresh',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'pre-replay-refresh', query],
})

export type InternalClearLoanLockKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'clear-lock',unknown];

export type InternalClearLoanLockResponse = void;

export type InternalClearLoanLockVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: void;
}

export const internalClearLoanLock = makeData<
  InternalClearLoanLockResponse,
  InternalClearLoanLockKey,
  InternalClearLoanLockVariables
>({
  method: 'post',
  name: 'internalClearLoanLock',
  summary: "Clear loan replay lock",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/clear-lock',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'clear-lock', query],
})

export type InternalReplayGetAllKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'replays',unknown];

export type InternalReplayGetAllResponse = ReplayTypes.ResponseGetReplaysResponse;

export type InternalReplayGetAllVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const internalReplayGetAll = makeData<
  InternalReplayGetAllResponse,
  InternalReplayGetAllKey,
  InternalReplayGetAllVariables
>({
  method: 'get',
  name: 'internalReplayGetAll',
  summary: "Get replays",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/replays',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'replays', query],
})

export type ReplayGetAllKey = ['people',string | undefined,'loans',string | undefined,'replays',unknown];

export type ReplayGetAllResponse = ReplayTypes.ResponseGetReplaysResponse;

export type ReplayGetAllVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const replayGetAll = makeData<
  ReplayGetAllResponse,
  ReplayGetAllKey,
  ReplayGetAllVariables
>({
  method: 'get',
  name: 'replayGetAll',
  summary: "Get replays",
  path: '/people/{personId}/loans/{loanId}/replays',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'replays', query],
})

export type InternalReplayGetKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'replays',string | undefined,unknown];

export type InternalReplayGetResponse = ReplayTypes.ResponseGetReplayResponse;

export type InternalReplayGetVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    replayIdOrCreatingMessageId: string | undefined;
    body?: void;
    query?: void;
}

export const internalReplayGet = makeData<
  InternalReplayGetResponse,
  InternalReplayGetKey,
  InternalReplayGetVariables
>({
  method: 'get',
  name: 'internalReplayGet',
  summary: "Get replays",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/replays/{replayIdOrCreatingMessageId}',
  queryKey: ({query, companyId,
personId,
loanId,
replayIdOrCreatingMessageId,}) => ['companies',companyId,'people',personId,'loans',loanId,'replays',replayIdOrCreatingMessageId, query],
})

export type ReplayGetKey = ['people',string | undefined,'loans',string | undefined,'replays',string | undefined,unknown];

export type ReplayGetResponse = ReplayTypes.ResponseGetReplayResponse;

export type ReplayGetVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    replayIdOrCreatingMessageId: string | undefined;
    body?: void;
    query?: void;
}

export const replayGet = makeData<
  ReplayGetResponse,
  ReplayGetKey,
  ReplayGetVariables
>({
  method: 'get',
  name: 'replayGet',
  summary: "Get replays",
  path: '/people/{personId}/loans/{loanId}/replays/{replayIdOrCreatingMessageId}',
  queryKey: ({query, personId,
loanId,
replayIdOrCreatingMessageId,}) => ['people',personId,'loans',loanId,'replays',replayIdOrCreatingMessageId, query],
})
